// Kwikpass Login
function autoLoginHeader(token) {
  const loginElements = document.querySelectorAll('.kp-login-button')
  const accountElements = document.querySelectorAll('.mobile-quick-nav')

  if (token) {
    loginElements.forEach(element => {
      element.classList.remove("kp-login-mbl");
    })

    accountElements.forEach(element => {
      element.classList.add("kp-account-mbl");
    })

    const logoutElements = document.querySelectorAll('a[data-section="logout"]');
    logoutElements.forEach((element) => {
      const parentElement = element.parentNode
      parentElement.style.display = "block"
    });

  } else {
    loginElements.forEach(element => {
      element.classList.add("kp-login-mbl");
    })

    accountElements.forEach(element => {
      element.classList.remove("kp-account-mbl");
    })

    const logoutElements = document.querySelectorAll('a[data-section="logout"]');
    logoutElements.forEach((element) => {
      const parentElement = element.parentNode
      parentElement.style.display = "none"
    });
  }
}

function conversionTracking() {
  // gtag('event', 'conversion', {
  //     'send_to': 'AW-360661310/BBKUCI_w28QaEL6C_asB',
  //     'value': 1.0,
  //     'currency': 'INR'
  //   });
    
    // Meta (Facebook) Conversion Tracking
    fbq('track', 'CompleteRegistration');
    console.log("Login Event trigger")
}

window.addEventListener('user-loggedin', function (event) {
  const { token } = event?.detail;
  autoLoginHeader(token);
  conversionTracking();
});

document.addEventListener('DOMContentLoaded', function () {
  var userToken = localStorage.getItem('KWIKSESSIONTOKEN');
  autoLoginHeader(userToken);
})


// Megamenu Images
class MegamenuImage extends HTMLElement {
  constructor() {
    super();
    this.initMegaMenu();
  }
  initMegaMenu() {
    // Getting the parent under which we need to show the menu
    this.parentMenuHandle = this.dataset['dropdown'];
    this.parentMenu = document.querySelector(`.mega-menu__content[data-submenu="${this?.parentMenuHandle}"]`);

    if (this.parentMenuHandle && this.parentMenu) {
      this.parentMenu.closest('header-menu')?.classList.add('mm_mega-menu');
      let imgOnDesktop = this.querySelector('.mm-megamenu--image');
      let megamenuMobile = document.querySelector(`.mm-mobile-parent[data-link="${this?.parentMenuHandle}"]`);
      let contentOnMobile = this.querySelector('.mm-megamenu-mobile');

      if (imgOnDesktop) {
        this.parentMenu.appendChild(imgOnDesktop.cloneNode(true));
      }

      if (megamenuMobile && contentOnMobile) { // Ensure both elements are found
        megamenuMobile.appendChild(contentOnMobile.cloneNode(true));
      }
    }
  }
}

customElements.define('megamenu-image', MegamenuImage);

// To Handle mobile megamenu
function handleOverlayMegamenuClick(element) {
  const dataLink = element.getAttribute('data-link');
  const overlaySubmenus = document.querySelectorAll('.overlay-submenu');

  overlaySubmenus.forEach(function (overlaySubmenu) {
    const dataSublink = overlaySubmenu.getAttribute('data-sublink');
    if (dataLink === dataSublink) {
      overlaySubmenu.classList.add('overlay-submenu-slide');
    } else {
      overlaySubmenu.classList.remove('overlay-submenu-slide');
    }
  });
}

function handleIconCloseClick(element) {
  const overlaySubmenu = element.closest('.overlay-submenu');
  overlaySubmenu.classList.remove('overlay-submenu-slide');
}
